import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";

const cls = "border-[#163D43] bg-[#041214] text-teal-50";
const today = () => new Date().toLocaleDateString("en-CA");

const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <label className="text-xs uppercase tracking-wider text-teal-300">{label}</label>
    {children}
  </div>
);

export const TrackingForm = ({ item, onClose, onSaved }) => {
  const [services, setServices] = useState([]);
  const [form, setForm] = useState(item || { client_name: "", client_phone: "", service_title: "", deadline_days: 4, start_date: today() });
  useEffect(() => {
    http.get("/admin/services").then((r) => setServices(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const pickService = (title) => {
    const s = services.find((x) => x.title === title);
    setForm((f) => ({ ...f, service_title: title, deadline_days: s?.deadline_days ?? f.deadline_days }));
  };
  const save = async () => {
    const body = { client_name: form.client_name, client_phone: form.client_phone, service_title: form.service_title, deadline_days: Number(form.deadline_days), start_date: form.start_date };
    try {
      const { data } = item?.id ? await http.put(`/admin/tracking/${item.id}`, body) : await http.post("/admin/tracking", body);
      toast.success(item?.id ? "Pedido atualizado" : `Pedido ${data.code} criado`);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md border-[#163D43] bg-[#071D1F] text-teal-50" data-testid="tracking-form-dialog">
        <DialogHeader><DialogTitle className="font-display">{item?.id ? `Editar ${item.code}` : "Novo pedido"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Nome do cliente"><Input value={form.client_name} onChange={(e) => set("client_name", e.target.value)} className={cls} data-testid="tracking-client-name" /></Field>
          <Field label="WhatsApp do cliente"><Input value={form.client_phone} onChange={(e) => set("client_phone", e.target.value)} placeholder="51 99999-9999" className={cls} data-testid="tracking-client-phone" /></Field>
          <Field label="Serviço">
            <select value={form.service_title} onChange={(e) => pickService(e.target.value)} className={`h-9 w-full rounded-md border px-3 text-sm ${cls}`} data-testid="tracking-service">
              <option value="">Selecione...</option>
              {services.map((s) => <option key={s.id} value={s.title}>{s.title} — {s.deadline_days ?? 4} dias úteis</option>)}
              {form.service_title && !services.some((s) => s.title === form.service_title) && <option value={form.service_title}>{form.service_title}</option>}
            </select>
          </Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Início (pagamento)"><Input type="date" value={form.start_date} onChange={(e) => set("start_date", e.target.value)} className={cls} data-testid="tracking-start-date" /></Field>
            <Field label="Prazo (dias úteis)"><Input type="number" min={0} value={form.deadline_days} onChange={(e) => set("deadline_days", e.target.value)} className={cls} data-testid="tracking-deadline-days" /></Field>
          </div>
        </div>
        <button onClick={save} data-testid="tracking-save" className="mt-2 w-full rounded-full bg-[#2DD4BF] py-3 font-semibold text-[#041214]">Salvar</button>
      </DialogContent>
    </Dialog>
  );
};
